import { OutputDateRange } from "src/features/PageConfigProvider/types/OutputDateRange";

export enum FilterFieldsKeys {
  CreationTime = "creationTime",
  LastModifiedTime = "lastModifiedTime",
  ChainName = "chainName",
  BatchId = "batchId",
  Status = "status",
  OperationType = "operationType",
}

export type FilterFields = {
  [FilterFieldsKeys.CreationTime]: OutputDateRange;
  [FilterFieldsKeys.LastModifiedTime]: OutputDateRange;
  [FilterFieldsKeys.ChainName]: string;
  [FilterFieldsKeys.BatchId]: string;
  [FilterFieldsKeys.Status]: string[];
  [FilterFieldsKeys.OperationType]: string[];
};
